import React, {useEffect, useRef, useState} from "react";
import "./ProductVideos.scss";
import p1 from "./imgs/1.jpg";
import p2 from "./imgs/2.jpg";
import p3 from "./imgs/3.jpg";
import p4 from "./imgs/4.jpg";
import MCure6 from "./videos/M-Cure 6.mp4";
import RPEX9 from "./videos/RPEX 9.mov";
import UltraR6 from "./videos/Ultra R6.mp4";
import RSmartWClassic from "./videos/R-Smart W-Classic.mp4";
import playicon from './imgs/play.svg';
import useForceUpdate from "../../../../utils/useForceUpdate";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";

const resources = {
    MCure6,
    RPEX9,
    UltraR6,
    RSmartWClassic
};

export function ProductVideos() {
    const lang = LOCALES_HELPER.getLan();

    const [vedio, setVedio] = useState({
        src: null,
        title: ""
    });
    const myVedio = useRef();

    function handleClose() {
        setVedio({
            src: null,
            title: ""
        })
        myVedio.current.pause();
    }

    useEffect(() => {
        new window.Swiper('.swiper-container.product-vedio-banner', {
            pagination: '.swiper-pagination',
            nextButton: '.swiper-button-next.vedio-banner',
            prevButton: '.swiper-button-prev.vedio-banner',
            paginationClickable: true,
            slidesPerView: 3,
            loopedSlides: 4,
            spaceBetween: 80,
            centeredSlides: true,
            loop: true,
            onClick: function (s, event) {
                if (s.clickedSlide) {
                    let who = s.clickedSlide.getAttribute("date-href"); //获取当前slide是谁
                    let playRef = s.clickedSlide.querySelector(".playicon"); // 查找该slide的播放按钮
                    if (event.target != playRef) return;

                    setVedio({
                        src: resources[who],
                        title: who
                    });
                }
            },
        });
    }, []);

    return <>
        <section className="pt-medium pb-medium light-color effect-zoe clearfix portfolio-mosaic">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 text-center heading blue-color">
                        <h1><span>{lang === DEFAULT_LOCALE?"视频演示":""}</span>Videos Show</h1>
                    </div>
                </div>
            </div>
            <div className="swiper-container product-vedio-banner">
                <div className="swiper-wrapper">
                    <div className="swiper-slide" date-href='MCure6'>
                        <article>
                            <figure>
                                <img src={p3} alt="EDENA premium website template"
                                     className="full-width"/>
                                <div className="playicon-wrapper">
                                    <img className="playicon"
                                         data-toggle="modal"
                                         data-target=".bs-example-modal-lg"
                                         src={playicon}
                                    />
                                </div>
                            </figure>
                        </article>
                    </div>
                    <div className="swiper-slide" date-href='RPEX9'>
                        <article>
                            <figure>
                                <img src={p2} alt="EDENA premium website template" className="full-width"/>
                                <div className="playicon-wrapper">
                                    <img className="playicon"
                                         data-toggle="modal"
                                         data-target=".bs-example-modal-lg"
                                         src={playicon}
                                    />
                                </div>
                            </figure>
                        </article>
                    </div>
                    <div className="swiper-slide" date-href='RSmartWClassic'>
                        <article>
                            <figure>
                                <img src={p1} alt="EDENA premium website template" className="full-width"/>
                                <div className="playicon-wrapper">
                                    <img className="playicon" data-toggle="modal"
                                         data-target=".bs-example-modal-lg" src={playicon}/>
                                </div>
                            </figure>
                        </article>
                    </div>
                    <div className="swiper-slide" date-href='UltraR6'>
                        <article>
                            <figure>
                                <img src={p4} alt="EDENA premium website template" className="full-width"/>
                                <div className="playicon-wrapper">
                                    <img className="playicon" data-toggle="modal"
                                         data-target=".bs-example-modal-lg" src={playicon}/>
                                </div>
                            </figure>
                        </article>
                    </div>

                </div>
                <div className="swiper-pagination"></div>
                <div className="swiper-button-next vedio-banner"></div>
                <div className="swiper-button-prev vedio-banner"></div>
            </div>

        </section>

        <div className="modal fade bs-example-modal-lg no-header" tabIndex="-1" role="dialog"
             data-backdrop="static"
             aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" onClick={handleClose} className="close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                            <span className="sr-only">Close</span>
                        </button>
                        <h4 className="modal-title">{vedio.title}</h4>
                    </div>
                    <div className="modal-body">
                        <video ref={myVedio} src={vedio.src} controls width="100%" height="100%" autoPlay>
                            您的浏览器不支持，请更换浏览器再试～
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </>
}
